// GlobalRadioGroup.js
import React from "react";
import {
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
} from "@mui/material";

const GlobalRadioGroup = ({
  required = false,
  options = [],
  value,
  onChange,
  color = "#6A0DAD", // default purple
  row = true,


}) => {
  return (

      <RadioGroup row={row} value={value} onChange={onChange}>
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={
              <Radio
                sx={{
                  color: color,
                  "&.Mui-checked": { color: color },
                }}
              />
            }
            label={
              <Typography
                sx={{
                  color: value === option.value ? color : "inherit",
                  fontWeight: value === option.value ? 500 : 400,
                }}
              >
                {option.label}
              </Typography>
            }
          />
        ))}
      </RadioGroup>
  
  );
};

export default GlobalRadioGroup;
